import { useCallback } from "react";

import groupBy from "lodash/groupBy";
import { useMutation } from "react-query";
import { getLanContent } from "utils";

import { masterDataCountryListService } from "./services";

export const useCountryListByIds = () => {
  const { mutateAsync: getListCountry } = useMutation({
    mutationKey: "masterDataCountryListServiceOption",
    mutationFn: masterDataCountryListService,
  });

  const getListCountryByIds = useCallback(
    async (ids: number[]) => {
      try {
        if (!ids?.length) return {};

        const data = await getListCountry({ ids });
        const dataTransform = data?.data?.items?.map((item) => ({
          id: item.id,
          name: getLanContent(item, "name"),
        }));
        return groupBy(dataTransform, "id") || [];
      } catch {
        return {};
      }
    },
    [getListCountry]
  );

  return {
    getListCountryByIds,
  };
};
